import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../components/AppIcon';
import Button from '../../components/ui/Button';
import TopNavbar from '../../components/ui/TopNavbar';
import GenerateInvoiceModal from '../accounts-receivable/components/GenerateInvoiceModal';
import InvoiceTemplate from '../accounts-receivable/components/InvoiceTemplate';

const Invoices = () => {
  const navigate = useNavigate();
  const [isGenerateModalOpen, setIsGenerateModalOpen] = useState(false);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [invoiceToEdit, setInvoiceToEdit] = useState(null);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [invoices, setInvoices] = useState([
    {
      id: 'INV-2025-001',
      date: '2025-01-15',
      month: 'January 2025',
      invoiceMonth: '2025-01',
      client: 'RNR Steels and Metals',
      shipmentRef: 'SHP-2025-001',
      vesselName: 'Star Navigator',
      tonnage: 380000,
      feeRate: 3.5,
      usdAmount: 1330000,
      audAmount: 2021600,
      inrAmount: 111005000,
      status: 'approved',
      approvalStatus: 'approved',
      origin: 'Newcastle, Australia',
      destination: 'Kandla Port, India',
      coalType: 'Thermal Coal - 5800 GAR',
      description: 'Coal Trading Management Services - January 2025',
      paymentTerms: 'Net 30',
      dueDate: '2025-02-15'
    },
    {
      id: 'INV-2025-002',
      date: '2025-02-15',
      month: 'February 2025',
      invoiceMonth: '2025-02',
      client: 'RNR Steels and Metals',
      shipmentRef: 'SHP-2025-015',
      vesselName: 'Maritime Express',
      tonnage: 265000,
      feeRate: 3.5,
      usdAmount: 927500,
      audAmount: 1409800,
      inrAmount: 77446250,
      status: 'approved',
      approvalStatus: 'approved',
      origin: 'Dalrymple Bay, Australia',
      destination: 'Paradip Port, India',
      coalType: 'Thermal Coal - 5500 GAR',
      description: 'Coal Trading Management Services - February 2025',
      paymentTerms: 'Net 30',
      dueDate: '2025-03-15'
    },
    {
      id: 'INV-2024-012',
      date: '2024-12-15',
      month: 'December 2024',
      invoiceMonth: '2024-12',
      client: 'RNR Steels and Metals',
      shipmentRef: 'SHP-2024-125',
      vesselName: 'Pacific Glory',
      tonnage: 320000,
      feeRate: 3.5,
      usdAmount: 1120000,
      audAmount: 1702400,
      inrAmount: 93520000,
      status: 'approved',
      approvalStatus: 'approved',
      origin: 'Newcastle, Australia',
      destination: 'Mundra Port, India',
      coalType: 'Thermal Coal - 5500 GAR',
      description: 'Coal Trading Management Services - December 2024',
      paymentTerms: 'Net 30',
      dueDate: '2025-01-15'
    },
    {
      id: 'INV-2024-011',
      date: '2024-11-15',
      month: 'November 2024',
      invoiceMonth: '2024-11',
      client: 'RNR Steels and Metals',
      shipmentRef: 'SHP-2024-112',
      vesselName: 'Horizon Voyager',
      tonnage: 340000,
      feeRate: 3.5,
      usdAmount: 1190000,
      audAmount: 1808800,
      inrAmount: 99365000,
      status: 'approved',
      approvalStatus: 'approved',
      origin: 'Brisbane, Australia',
      destination: 'Chennai Port, India',
      coalType: 'Thermal Coal - 5700 GAR',
      description: 'Coal Trading Management Services - November 2024',
      paymentTerms: 'Net 30',
      dueDate: '2024-12-15'
    },
    {
      id: 'INV-2024-013',
      date: '2024-12-20',
      month: 'December 2024',
      invoiceMonth: '2024-12',
      client: 'RNR Steels and Metals',
      shipmentRef: 'SHP-2024-130',
      vesselName: 'Global Trader',
      tonnage: 185000,
      feeRate: 3.5,
      usdAmount: 647500,
      audAmount: 984200,
      inrAmount: 54066250,
      status: 'pending',
      approvalStatus: 'pending',
      origin: 'Hay Point, Australia',
      destination: 'Tuticorin Port, India',
      coalType: 'Thermal Coal - 6200 GAR',
      description: 'Coal Trading Management Services - December 2024',
      paymentTerms: 'Net 30',
      dueDate: '2025-01-20'
    },
    {
      id: 'INV-2024-014',
      date: '2024-12-05',
      month: 'December 2024',
      invoiceMonth: '2024-12',
      client: 'RNR Steels and Metals',
      shipmentRef: 'SHP-2024-140',
      vesselName: 'Coastal Pride',
      tonnage: 420000,
      feeRate: 3.5,
      usdAmount: 1470000,
      audAmount: 2234400,
      inrAmount: 122745000,
      status: 'pending',
      approvalStatus: 'approved',
      origin: 'Port Kembla, Australia',
      destination: 'Krishnapatnam Port, India',
      coalType: 'Thermal Coal - 5500 GAR',
      description: 'Coal Trading Management Services - December 2024',
      paymentTerms: 'Net 30',
      dueDate: '2025-01-05'
    },
    {
      id: 'INV-2024-010',
      date: '2024-11-25',
      month: 'November 2024',
      invoiceMonth: '2024-11',
      client: 'RNR Steels and Metals',
      shipmentRef: 'SHP-2024-135',
      vesselName: 'Neptune Star',
      tonnage: 225000,
      feeRate: 3.5,
      usdAmount: 787500,
      audAmount: 1197000,
      inrAmount: 65756250,
      status: 'approved',
      approvalStatus: 'approved',
      origin: 'Newcastle, Australia',
      destination: 'Haldia Port, India',
      coalType: 'Thermal Coal - 6000 GAR',
      description: 'Coal Trading Management Services - November 2024',
      paymentTerms: 'Net 30',
      dueDate: '2024-12-25'
    },
    {
      id: 'INV-2024-009',
      date: '2024-11-05',
      month: 'November 2024',
      invoiceMonth: '2024-11',
      client: 'RNR Steels and Metals',
      shipmentRef: 'SHP-2024-108',
      vesselName: 'Atlantic Voyager',
      tonnage: 295000,
      feeRate: 3.5,
      usdAmount: 1032500,
      audAmount: 1569400,
      inrAmount: 86213750,
      status: 'approved',
      approvalStatus: 'approved',
      origin: 'Gladstone, Australia',
      destination: 'Ennore Port, India',
      coalType: 'Thermal Coal - 6100 GAR',
      description: 'Coal Trading Management Services - October 2024',
      paymentTerms: 'Net 30',
      dueDate: '2024-12-05'
    },
    {
      id: 'INV-2025-003',
      date: '2025-03-15',
      month: 'March 2025',
      invoiceMonth: '2025-03',
      client: 'RNR Steels and Metals',
      shipmentRef: 'SHP-2025-022',
      vesselName: 'Southern Cross',
      tonnage: 355000,
      feeRate: 3.5,
      usdAmount: 1242500,
      audAmount: 1888600,
      inrAmount: 103748750,
      status: 'pending',
      approvalStatus: 'pending',
      origin: 'Newcastle, Australia',
      destination: 'Mundra Port, India',
      coalType: 'Thermal Coal - 5900 GAR',
      description: 'Coal Trading Management Services - March 2025',
      paymentTerms: 'Net 30',
      dueDate: '2025-04-15'
    },
    {
      id: 'INV-2024-008',
      date: '2024-10-15',
      month: 'October 2024',
      invoiceMonth: '2024-10',
      client: 'RNR Steels and Metals',
      shipmentRef: 'SHP-2024-095',
      vesselName: 'Pacific Monarch',
      tonnage: 410000,
      feeRate: 3.5,
      usdAmount: 1435000,
      audAmount: 2181200,
      inrAmount: 119822500,
      status: 'approved',
      approvalStatus: 'approved',
      origin: 'Dalrymple Bay, Australia',
      destination: 'Vizag Port, India',
      coalType: 'Thermal Coal - 5600 GAR',
      description: 'Coal Trading Management Services - September 2024',
      paymentTerms: 'Net 30',
      dueDate: '2024-11-15'
    },
    {
      id: 'INV-2024-015',
      date: '2024-12-28',
      month: 'December 2024',
      invoiceMonth: '2024-12',
      client: 'RNR Steels and Metals',
      shipmentRef: 'SHP-2024-150',
      vesselName: 'Eastern Star',
      tonnage: 275000,
      feeRate: 3.5,
      usdAmount: 962500,
      audAmount: 1463000,
      inrAmount: 80368750,
      status: 'pending',
      approvalStatus: 'approved',
      origin: 'Hay Point, Australia',
      destination: 'Kandla Port, India',
      coalType: 'Thermal Coal - 6300 GAR',
      description: 'Coal Trading Management Services - December 2024',
      paymentTerms: 'Net 30',
      dueDate: '2025-01-28'
    },
    {
      id: 'INV-2024-007',
      date: '2024-12-01',
      month: 'December 2024',
      invoiceMonth: '2024-12',
      client: 'RNR Steels and Metals',
      shipmentRef: 'SHP-2024-118',
      vesselName: 'Ocean Harmony',
      tonnage: 150000,
      feeRate: 3.5,
      usdAmount: 525000,
      audAmount: 798000,
      inrAmount: 43837500,
      status: 'approved',
      approvalStatus: 'approved',
      origin: 'Gladstone, Australia',
      destination: 'Vizag Port, India',
      coalType: 'Thermal Coal - 6000 GAR',
      description: 'Coal Trading Management Services - November 2024',
      paymentTerms: 'Net 30',
      dueDate: '2025-01-01'
    }
  ]);

  const [filterStatus, setFilterStatus] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');

  const handleCreateInvoice = () => {
    setShowCreateModal(true);
  };

  const handleSaveInvoice = (invoiceData) => {
    console.log('Creating invoice:', invoiceData);
    // TODO: Implement invoice creation
    alert('✅ Invoice created successfully!');
    setShowCreateModal(false);
  };

  const handleEditInvoice = (invoiceId) => {
    console.log('Editing invoice:', invoiceId);
    setShowEditModal(true);
    // TODO: Load invoice data
  };

  const handleUpdateInvoice = (invoiceData) => {
    console.log('Updating invoice:', invoiceData);
    // TODO: Implement update
    alert('✅ Invoice updated successfully!');
    setShowEditModal(false);
  };

  const handleSendInvoice = (invoiceId) => {
    console.log('Sending invoice:', invoiceId);
    // TODO: Implement email sending
    alert('✅ Invoice sent to customer!');
  };

  const handleDownloadInvoice = (invoiceId) => {
    console.log('Downloading invoice:', invoiceId);
    // TODO: Implement PDF download
    alert('✅ Invoice PDF downloaded!');
  };

  const handleMarkAsPaid = (invoiceId) => {
    console.log('Marking as paid:', invoiceId);
    // TODO: Implement payment recording
    alert('✅ Invoice marked as paid!');
  };

  const handleVoidInvoice = (invoiceId) => {
    if (confirm('Are you sure you want to void this invoice?')) {
      console.log('Voiding invoice:', invoiceId);
      // TODO: Implement void
      alert('✅ Invoice voided!');
    }
  };

  const handleExportInvoices = () => {
    console.log('Exporting invoices');
    // TODO: Implement export
    alert('✅ Exporting invoices...');
  };

  const handleGenerateInvoice = (newInvoice) => {
    if (isEditMode && invoiceToEdit) {
      // Update existing invoice
      setInvoices((prev) => 
        prev?.map(inv => inv?.id === invoiceToEdit?.id ? { ...newInvoice, id: invoiceToEdit?.id } : inv)
      );
      setIsEditMode(false);
      setInvoiceToEdit(null);
    } else {
      // Add new invoice
      setInvoices((prev) => [newInvoice, ...prev]);
    }
    setIsGenerateModalOpen(false);
  };

  const handleApproveInvoice = (invoice) => {
    setInvoices((prev) =>
      prev?.map((inv) =>
        inv?.id === invoice?.id
          ? { ...inv, status: 'approved', approvalStatus: 'approved' }
          : inv
      )
    );
  };

  const filteredInvoices = invoices?.filter((invoice) => {
    const matchesStatus = filterStatus === 'all' || invoice?.status === filterStatus;
    const matchesSearch =
      invoice?.id?.toLowerCase()?.includes(searchTerm?.toLowerCase()) ||
      invoice?.month?.toLowerCase()?.includes(searchTerm?.toLowerCase());
    return matchesStatus && matchesSearch;
  });

  const getStatusBadge = (status) => {
    const statusConfig = {
      approved: { color: 'bg-green-100 text-green-800', label: 'Approved' },
      pending: { color: 'bg-yellow-100 text-yellow-800', label: 'Pending' },
      rejected: { color: 'bg-red-100 text-red-800', label: 'Rejected' },
    };
    const config = statusConfig?.[status] || statusConfig?.pending;
    return (
      <span className={`px-2 py-1 rounded-full text-xs font-medium ${config?.color}`}>
        {config?.label}
      </span>
    );
  };

  const formatCurrency = (amount, currency = 'USD') => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    })?.format(amount);
  };

  return (
    <div className="flex flex-col min-h-screen bg-background">
      <TopNavbar />
      <div className="flex-1 flex flex-col overflow-hidden mt-[65px]">
        <header className="bg-card border-b border-border px-3 sm:px-4 md:px-6 py-3 sm:py-4 sticky top-[65px] z-20">
          <div className="flex flex-col gap-3 sm:gap-4">
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
              <div className="flex-1 min-w-0">
                <h1 className="text-lg sm:text-xl md:text-2xl font-semibold text-foreground truncate">
                  Invoice Management
                </h1>
                <p className="text-xs sm:text-sm text-muted-foreground mt-1 line-clamp-2">
                  Centralized invoice processing and tracking
                </p>
              </div>
              
              <div className="flex items-center gap-2 flex-wrap">
                <Button
                  variant="default"
                  iconName="Plus"
                  iconPosition="left"
                  className="text-xs sm:text-sm px-3 sm:px-4 py-2 min-h-[44px] sm:min-h-auto"
                >
                  New Invoice
                </Button>
                <Button
                  variant="outline"
                  iconName="Upload"
                  iconPosition="left"
                  className="text-xs sm:text-sm px-3 sm:px-4 py-2 min-h-[44px] sm:min-h-auto"
                >
                  <span className="hidden sm:inline">Upload</span>
                  <Icon name="Upload" size={16} className="sm:hidden" />
                </Button>
              </div>
            </div>

            {/* Status filters - mobile scrollable */}
            <div className="flex items-center gap-2 overflow-x-auto pb-2 -mx-3 px-3 sm:mx-0 sm:px-0 no-scrollbar">
              {/* Filter chips here */}
            </div>
          </div>
        </header>

        <div className="flex-1 overflow-auto p-3 sm:p-4 md:p-6">
          {/* Search and filters */}
          <div className="mb-4 flex flex-col sm:flex-row gap-3">
            <div className="flex-1">
              <input
                type="text"
                placeholder="Search by Invoice ID or Month..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e?.target?.value)}
                className="w-full px-4 py-2 border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
              />
            </div>
            <select
              value={filterStatus}
              onChange={(e) => setFilterStatus(e?.target?.value)}
              className="px-4 py-2 border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
            >
              <option value="all">All Status</option>
              <option value="approved">Approved</option>
              <option value="pending">Pending</option>
              <option value="rejected">Rejected</option>
            </select>
            <Button
              variant="outline"
              onClick={handleExportInvoices}
              iconName="Download"
              iconPosition="left"
            >
              Export
            </Button>
          </div>

          {/* Invoice Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {filteredInvoices?.length === 0 ? (
              <div className="col-span-full text-center py-12 text-muted-foreground">
                No invoices found
              </div>
            ) : (
              filteredInvoices?.map((invoice) => (
                <div
                  key={invoice?.id}
                  className="bg-card border border-border rounded-lg p-4 hover:shadow-lg transition-shadow cursor-pointer"
                  onClick={() => setSelectedInvoice(invoice)}
                >
                  <div className="flex items-start justify-between mb-3">
                    <div>
                      <h3 className="text-lg font-semibold text-foreground">
                        {invoice?.id}
                      </h3>
                      <p className="text-sm text-muted-foreground">{invoice?.month}</p>
                    </div>
                    {getStatusBadge(invoice?.status)}
                  </div>

                  <div className="space-y-2 mb-4">
                    <div className="flex items-center justify-between text-sm">
                      <span className="text-muted-foreground">Client:</span>
                      <span className="font-medium text-foreground">{invoice?.client}</span>
                    </div>
                    <div className="flex items-center justify-between text-sm">
                      <span className="text-muted-foreground">Vessel:</span>
                      <span className="font-medium text-foreground">{invoice?.vesselName}</span>
                    </div>
                    <div className="flex items-center justify-between text-sm">
                      <span className="text-muted-foreground">Tonnage:</span>
                      <span className="font-medium text-foreground">
                        {invoice?.tonnage?.toLocaleString()} MT
                      </span>
                    </div>
                    <div className="flex items-center justify-between text-sm">
                      <span className="text-muted-foreground">Route:</span>
                      <span className="font-medium text-foreground text-right text-xs">
                        {invoice?.origin?.split(',')?.[0]} → {invoice?.destination?.split(',')?.[0]}
                      </span>
                    </div>
                  </div>

                  <div className="border-t border-border pt-3">
                    <div className="flex items-center justify-between mb-2">
                      <span className="text-sm text-muted-foreground">Amount (USD):</span>
                      <span className="text-lg font-bold text-foreground">
                        {formatCurrency(invoice?.usdAmount)}
                      </span>
                    </div>
                    <div className="flex items-center justify-between text-xs text-muted-foreground">
                      <span>Due: {new Date(invoice?.dueDate)?.toLocaleDateString()}</span>
                      <span>{invoice?.paymentTerms}</span>
                    </div>
                  </div>

                  <div className="flex items-center gap-2 mt-4 pt-3 border-t border-border">
                    <button
                      onClick={(e) => {
                        e?.stopPropagation();
                        handleSendInvoice(invoice?.id);
                      }}
                      className="flex-1 flex items-center justify-center gap-2 px-3 py-2 text-sm bg-blue-100 text-blue-700 rounded-lg hover:bg-blue-200 transition-colors"
                    >
                      <Icon name="Send" size={16} />
                      Send
                    </button>
                    <button
                      onClick={(e) => {
                        e?.stopPropagation();
                        handleDownloadInvoice(invoice?.id);
                      }}
                      className="flex-1 flex items-center justify-center gap-2 px-3 py-2 text-sm bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors"
                    >
                      <Icon name="Download" size={16} />
                      PDF
                    </button>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      </div>
      {/* Modals */}
      {isGenerateModalOpen && (
        <GenerateInvoiceModal
          isOpen={isGenerateModalOpen}
          onClose={() => {
            setIsGenerateModalOpen(false);
            setIsEditMode(false);
            setInvoiceToEdit(null);
          }}
          onGenerate={handleGenerateInvoice}
          existingInvoices={invoices}
          shipments={[]}
          editMode={isEditMode}
          invoiceToEdit={invoiceToEdit}
        />
      )}
      {selectedInvoice && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50">
          <div className="bg-background rounded-lg max-w-4xl w-full max-h-[90vh] overflow-y-auto">
            <div className="sticky top-0 bg-background border-b border-border p-4 flex items-center justify-between z-10">
              <h2 className="text-xl font-semibold text-foreground">Invoice Preview</h2>
              <button
                onClick={() => setSelectedInvoice(null)}
                className="text-muted-foreground hover:text-foreground transition-colors"
              >
                <Icon name="X" size={24} />
              </button>
            </div>
            <div className="p-6">
              <InvoiceTemplate 
                invoice={selectedInvoice} 
                isOpen={true}
                onClose={() => setSelectedInvoice(null)}
                onEdit={handleEditInvoice}
                onApprove={handleApproveInvoice}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Invoices;